import { FC, useState } from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { Props } from '../../../AddExperiencePage'
import { ErrorMessage, useFormikContext } from 'formik';
import { defaultHorizontalImage } from '../../../../../utils/constants';
import { useHistory } from 'react-router-dom';
import { SectionActive } from '../../../../partnerExperiences/components/SectionActive';
import { SectionExperiencesPast } from '../../SectionExperiencesPast';
import { UserModel } from '../../../../../modules/auth/models/UserModel';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../../../setup';
import { hasRole } from '../../../../../utils/permissions';
import { UserRole } from '../../../../../constants/roles';

import { SectionPartnerSuggestions } from '../../SectionPartnerSuggestions';

const Step1: FC<Props> = ({ onNextStep }) => {
    const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const formik = useFormikContext<any>();
    const history = useHistory();
    const isPartner = hasRole(user, UserRole.PARTNER);

    const renderContentOptionSelected = () => {
        switch (formik.values.experienceType) {
            case "new":
                return (<div className="tap-add-experience-2-btn-main" role='button' onClick={async () => await onNextStep()}>
                    <div className="tap-host-button-text tap-flex-center">
                        Create experience &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                    </div>
                </div>);
            case "past":
                return (<SectionExperiencesPast />);
            case "lead":
                return (<SectionActive />);
            case "suggestion":
                return (<SectionPartnerSuggestions onNextStep={onNextStep} />);
            default:
                return null;
        }
    }

    return (
        <div className="tap-add-experience-wrapper">
            <div className="tap-add-experience-container">
                <div className="tap-add-experience-title-box">
                    <div className="tap-add-experience-title">{isPartner ? 'Your Invitation to Nobilis' : 'Add experience'}</div>
                </div>

                <div className="tap-add-experience-section">
                    <div className="tap-add-experience-step">step 1/3</div>
                    <div className="tap-add-experience-divider"></div>

                    <div className="tap-add-experience-block">
                        <div className="tap-add-experience-subblock">
                            <div className="tap-add-experience-subtitle">Before You Begin</div>

                            <div className="tap-add-experience-text">
                                {isPartner ? 
                                `In Nobilis, every experience is more than an event—it is your gift to the community. What feels ordinary to you may be extraordinary to others. Your team may assist, but your presence as host is essential. Share your world, inspire connections, and create lasting moments.` : 
                                `Nobilis is a member-led community defined by personal engagement, trust, and excellence.
                                If you are submitting an experience, your presence is required—whether as the main host or a meaningful participant. Your involvement sets the tone and reflects the integrity of the invitation.
                                Now, curate something unforgettable. Share your world with peers who value authenticity, discretion, and brilliance.`}
                            </div>
                        </div>
                        <img className="tap-add-experience-image" src={defaultHorizontalImage} />
                    </div>

                    <div className="tap-host-info-box">
                        <div className="tap-host-info-text">
                            Please read <span className="tap-host-link" onClick={() => history.push('/experience/guide')}>Nobilis Experience Guide</span> before continuing
                        </div>
                    </div>

                    <div className="tap-host-options">
                        <div className="tap-host-option-card">

                            {/* Radio 1 */}
                            <label className="tap-host-option">
                                <input
                                    type="radio"
                                    name="experienceType"
                                    value="new"
                                    className="tap-host-radio-input"
                                    checked={formik.values.experienceType === "new"}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">
                                    {isPartner ? 'Create new experience' : 'Add new experience'}
                                </div>
                            </label>

                            {/* Radio 2 */}
                            <label className="tap-host-option">
                                <input
                                    type="radio"
                                    name="experienceType"
                                    value="past"
                                    className="tap-host-radio-input"
                                    checked={formik.values.experienceType === "past"}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">
                                    {isPartner ? 'Create from past experience' : 'Add experience based on past experience'}
                                </div>
                            </label>

                            {/* Radio 3 */}
                            <label className="tap-host-option">
                                <input
                                    type="radio"
                                    name="experienceType"
                                    value={isPartner ? 'suggestion' : 'lead'}
                                    className="tap-host-radio-input"
                                    checked={formik.values.experienceType === (isPartner ? 'suggestion' : 'lead')}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">
                                    {isPartner ? 'Create from Suggestion' : 'Experience you lead'}
                                </div>
                            </label>
                        </div>
                    </div>
                    <ErrorMessage name="experienceType" component="div" className="tap-add-experience-text text-danger" />
                </div>

                <div className="tap-add-experience-footer">
                    {renderContentOptionSelected()}
                </div>
            </div>
        </div>

    )
}

export { Step1 }
